$.fn.serviceNetworkFilter = function (options) {
    var defaults = {
      allValue: 'all-continent',
      emptyFilterClass: 'lang-filter__item--hide',
      hideContactClass: 'contacts__item--hide',
      contacts: '[data-filter="element"]',
      filters: '[data-filter="filter"]'
    };
    var o = $.extend({}, defaults, options);
    var filters = $(o.filters);
    var contacts = $(o.contacts);

    // nejprve načteme filtry a dáme pryč ty u kterých není ani jeden kontakt
    filters.each(function() {
        var f = $(this);
        var filterValue = $("input", f).val(); // Získáme hodnotu radio buttonu
        if (filterValue) {
          var filterClass = '.' + filterValue; // Vytvoříme css třídu pro filtrování
          // Pokud neexistuje žádný prvek s odpovídající css třídou, přidáme třídu "empty"
          if (contacts.filter(filterClass).length === 0 && filterValue !== o.allValue) {
            f.addClass(o.emptyFilterClass);
          }
        }
      });

      // nabindujeme sledování kliknutí na položku filteru
      $("input", o.filters).on('change', function() {
        var fVal = $(this).val();
        contacts.removeClass(o.hideContactClass);
        // Projdeme všechny prvky v proměnné "contacts"
        contacts.each(function() {
            var contact = $(this);
            if (fVal === o.allValue) {
                contact.removeClass(o.hideContactClass);
            } else {
                // Pokud prvek nemá třídu odpovídající hodnotě radio buttonu, přidáme třídu "hide"
                if (!contact.hasClass(fVal)) {
                    contact.addClass(o.hideContactClass);
                }
            }
        });
      });
  };


// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/third/jquery.serviceNetworkFilter.js